export type ProjectBranch = 'hotelslabo' | 'foodslabo'

// サイトのテーマカラー（求人カードのアイコン・ボタン・バッジ = --feature-project-branch-color）。
// hotelslabo は $hotels-primary-color 相当、foodslabo は主要オレンジ。
export const PROJECT_BRANCH_COLORS: Record<ProjectBranch, string> = {
    hotelslabo: '#BB9B4E',
    foodslabo: '#FF9100',
}
